import { useMemo } from 'react'
import { useReadContracts } from 'wagmi'
import { keccak256, toBytes } from 'viem'
import { ACTIVE_CHAINS } from '@/config/chains'
import { getContractAddress } from '@/config/contracts'
import { playerRegistryAbi } from '@/abi/playerRegistryAbi'

const OPERATOR_ROLE = keccak256(toBytes('OPERATOR_ROLE'))

export function useOperatorRoleAcrossChains(account?: `0x${string}`) {
    const contracts = useMemo(() => {
        if (!account) return []
        return ACTIVE_CHAINS.flatMap((c) => {
            const addr = getContractAddress(c.id, 'playerRegistry')
            if (!addr) return []
            return [
                {
                    address: addr,
                    abi: playerRegistryAbi,
                    functionName: 'hasRole' as const,
                    args: [OPERATOR_ROLE, account] as const,
                    chainId: c.id,
                },
            ]
        })
    }, [account])

    const { data, isLoading, isError } = useReadContracts({
        contracts,
        allowFailure: true,
        query: { enabled: contracts.length > 0 },
    })

    const rolesByChain = useMemo<Record<number, boolean>>(() => {
        const out: Record<number, boolean> = {}
        contracts.forEach((c, i) => {
            const result = data?.[i]
            out[c.chainId] = result?.status === 'success' && result.result === true
        })
        return out
    }, [contracts, data])

    return { rolesByChain, isLoading, isError }
}
